import React from 'react';
import { LandingPage } from './pages/LandingPage';
import { TermsPage } from './pages/TermsPage';
import { PrivacyPage } from './pages/PrivacyPage';
import { CookiesPage } from './pages/CookiesPage';
import { RefundsPage } from './pages/RefundsPage';
export function App() {
  const path = window.location.pathname;
  return <>
      {path === '/terminos' ? <TermsPage data-id="element-0" /> : path === '/privacidad' ? <PrivacyPage data-id="element-1" /> : path === '/cookies' ? <CookiesPage data-id="element-2" /> : path === '/reembolsos' ? <RefundsPage data-id="element-3" /> : <LandingPage data-id="element-4" />}
    </>;
}